import React, { useState, useEffect } from 'react'
import { Button, Icon } from '@equinor/eds-core-react'
import styled from 'styled-components'
import { colors } from '@/styles'

interface ISortButton {
    onClick?: () => void
}

const SortButton: React.FC<ISortButton> = ({ onClick }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const sortLabel = 'Sort'

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    return (
        <>
            {windowWidth > 1024 ? (
                <>
                    <SortButtonStyled variant="outlined" onClick={onClick}>
                        <Icon name="swap_vertical"></Icon>
                        {sortLabel}
                    </SortButtonStyled>
                </>
            ) : (
                <>
                    <SortButtonStyled variant="outlined" onClick={onClick}>
                        <Icon name="swap_vertical"></Icon>
                        {windowWidth > 400 ? sortLabel : ''}
                    </SortButtonStyled>
                </>
            )}
        </>
    )
}

const SortButtonStyled = styled(Button)`
    border: 1px solid;
    width: 105px;
    height: 38px;
    border: none;
    padding: 0 16px;

    @media (max-width: 1024px) {
        border: 1px solid;
    }

    @media (max-width: 400px) {
        border: 1px solid;
        flex: 1;
        width: 85px;
        height: 40px;
    }
`

export default SortButton
